import M from 'backbone.marionette'
import T from './sommairebudget.html'
import TItem from './sommairebudgetlistitem.html'
import { minutesToTimeString } from '../../../utils/utils'
import Radio from 'backbone.radio';


const BudgetItem = M.View.extend({
    tagName: 'tr',
    template: _.template(TItem),
    serializeData: function(){
        const punches = this.getOption('mainModel').get('punches').filter(p => p.get('budget_id') == this.model.get('id'))
        const total = punches.reduce(function(acc, curr){ return acc + curr.get('punchTimeInMinutes')}, 0);
        return _.extend( this.model.toJSON(), {
            count : punches.length,
            total: total,
            traitee: this.getOption('mainModel').get('punchreport').get('traitee'),
            totalString: minutesToTimeString(total),
            cout: (total/60) * this.getOption('mainModel').get('punchreport').get('taux')
        })
    },
    events: {
        'click .btSelect': 'onSelectClick'
    },
    onSelectClick: function(){
        Radio.channel('punch').trigger('selectPunshByBudget', this.model.get('id'));
    },
})

const BudgetList = M.CollectionView.extend({
    tagName: 'tbody',
    childView : BudgetItem
})

export const SommaireBudget = M.View.extend({
    template: _.template(T),
    
    regions: {
        'list': {
            el: 'tbody',
            replaceElement: true
        }
    },
    initialize: function(){
    
    },
    onRender: function(){
        console.log('budgets',this.getOption('mainModel').get('budgets'))
        this.showChildView('list', new BudgetList({
            childViewOptions: {
                mainModel: this.getOption('mainModel')
            },
            collection: this.getOption('mainModel').get('budgets')
        }));
    },
});